var r = {};
export {
  r as __exports
};
//# sourceMappingURL=index.es316.js.map
